export default "__VITE_ASSET__DWrOKduT__";